module.exports = __webpack_public_path__ + "static/img/banner_chain.13541f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_chain.png
// module id = xhOE
// module chunks = 15